import {PropsWithChildren, useState} from 'react';
import {ClientProfile} from '@/api/dto/client-profile';
import ExpandCollapseArrow from 'patient-ping-remedy/packages/expand-collapse-arrow';
import ClientDemographicHeader from '@clients/profile_page/ClientDemographicHeader';
import ClientDemographicContent from '@clients/profile_page/ClientDemographicContent';
import {Wrapper, Header, HeaderItems, HeaderItem, HeaderArrow, Content} from '@clients/profile_page/ClientDemographics.styles';

type Props = PropsWithChildren & {
  patient?: ClientProfile;
  isOpen?: boolean;
  isLoading?: boolean;
  isDemographicsEditable?: boolean;
  isPhotoEditable?: boolean;
  isExpandable?: boolean;
  isElevated?: boolean
  onClick?(isOpen: boolean): void;
  linkName?: boolean;
  onDemographicsEdit?(): void;
  onPhotoEdit?(): void;
}

export default function ClientDemographics({
  patient,
  isOpen,
  isLoading,
  isDemographicsEditable,
  isPhotoEditable,
  isExpandable,
  isElevated,
  onClick,
  linkName,
  onDemographicsEdit,
  onPhotoEdit,
  children,
}: Props) {
  const [isUserOpen, setIsUserOpen] = useState(false);
  const isExpanded = isUserOpen || isOpen;

  const handleClick = () => {
    setIsUserOpen(!isExpanded);
    onClick?.(!isExpanded);
  };

  return (
    <Wrapper isElevated={isElevated} className={isExpanded ? 'open' : ''}>
      <Header
        data-testid="client-demographics-header"
        isExpandable={isExpandable}
        onClick={handleClick}
      >
        <HeaderItems>
          {children}
          {isExpandable && (
            <HeaderArrow>
              <ExpandCollapseArrow isOpen={!isExpanded} iconSize="lg" />
            </HeaderArrow>
          )}
          {ClientDemographicHeader({
            patient,
            isEditAvailable: isDemographicsEditable,
            onEdit: onDemographicsEdit,
            linkName,
          }).map((node, index) => (
            <HeaderItem key={index}>
              {node}
            </HeaderItem>
          ))}
        </HeaderItems>
      </Header>
      {isExpandable && isExpanded && (
        <Content>
          <ClientDemographicContent
            patient={patient}
            isLoading={isLoading}
            isEditAvailable={isPhotoEditable}
            onClick={onPhotoEdit}
          />
        </Content>
      )}
    </Wrapper>
  );
}
